import login from '../page/app/login/login'
import detail from '../page/app/machine/detail'
// 首页
import home from '../page/app/home/home'
// 水机详情
import warn from '../page/app/detail/warn'
import filter from '../page/app/detail/filter'
import remote from '../page/app/detail/remote'
// 远程设置中的下级页面
import lease from '../page/app/remote/setLease'
import runtime from '../page/app/remote/runTime'
import drain from '../page/app/remote/drain'
// 一键报修页面
import repair from '../page/app/detail/repair'
// 维修维护
import maintain from '../page/app/maintain/maintain'
import addrecord from '../page/app/maintain/addRecord'
// 个人主页
import user from '../page/app/user/user'
import feedback from '../page/app/user/feedBack'
import about from '../page/app/user/aoubtUs'
import user2 from '../page/app/user/user2'
// 消息
import message from '../page/app/message/message'
// 经销商下的项目页
import project from '../page/app/project/project'
import machines from '../page/app/project/machines'
// 图表
import water from '../page/app/chart/waterChart'
import electric from '../page/app/chart/electricChart'

export default {
  routes: [
    // 登录页
    {
      path: '/login',
      name: 'login',
      component: login
    },
    // 首页
    {
      path: '/',
      name: 'home',
      component: home
    },
    // 水机详情页
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    // 运行状态
    {
      path: '/warn',
      name: 'warn',
      component: warn
    },
    // 滤芯状态
    {
      path: '/filter',
      name: 'filter',
      component: filter
    },
    // 远程设置
    {
      path: '/remote',
      name: 'remote',
      component: remote
    },
    // 租赁设置
    {
      path: '/lease',
      name: 'lease',
      component: lease
    },
    // 运行时间
    {
      path: '/runtime',
      name: 'runtime',
      component: runtime
    },
    // 排水时间
    {
      path: '/drain',
      name: 'drain',
      component: drain
    },
    // 一键保修
    {
      path: '/repair',
      name: 'repair',
      component: repair
    },
    // 维修维护
    {
      path: '/maintain',
      name: 'maintain',
      component: maintain
    },
    // 添加记录
    {
      path: '/addrecord',
      name: 'addrecord',
      component: addrecord
    },
    // 个人主页
    {
      path: '/user',
      name: 'user',
      component: user
    },
    // 个人主页2
    {
      path: '/user2',
      name: 'user2',
      component: user2
    },
    // 意见反馈
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    // 联系我们
    {
      path: '/about',
      name: 'about',
      component: about
    },
    // 消息
    {
      path: '/message',
      name: 'message',
      component: message
    },
    // 经销商下的项目
    {
      path: '/project',
      name: 'project',
      component: project
    },
    // 项目下的开水器
    {
      path: '/machines',
      name: 'machines',
      component: machines
    },
    // 用水图表
    {
      path: '/water',
      name: 'water',
      component: water
    },
    // 用电图表
    {
      path: '/electric',
      name: 'electric',
      component: electric
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/app.js